import { ButtonColor, ButtonProps, ButtonSize } from './Button.types';
import { BUTTON_COLORS, BUTTON_SIZES } from './Button.theme';
import '../../../styles/Button.css';

export default ({
  children,
  isLoading,
  color = ButtonColor.Primary,
  size: btnSize = ButtonSize.Medium,
  disabled,
  className,
  startIcon: StartIcon,
  startIconProps,
  endIcon: EndIcon,
  endIconProps,
  style,
  ...props
}: ButtonProps) => {
  const { background, text, font } = BUTTON_COLORS[color];
  const { size } = BUTTON_SIZES[btnSize];

  return (
    <button
      className={`btn ${
        disabled ? 'btn-disabled' : background
      } ${text} ${font} ${size} ${className}`}
      style={{
        ...((StartIcon || EndIcon) && {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }),
        ...style,
      }}
      {...{ disabled }}
      {...props}>
      {isLoading ? (
        <div className="btn__loader" data-testid="loader"/>
      ) : (
        <>
          {StartIcon && <StartIcon style={{ position: 'relative', right: 5 }} {...startIconProps} />}
          {children}
          {EndIcon && <EndIcon style={{ position: 'relative', left: 5 }} {...endIconProps} />}
        </>
      )}
    </button>
  );
};
